export const UPDATE_BASIC_MESSAGE_ENTITY = 'update:basic_message_entity'
export const UPDATE_BASIC_MESSAGE_ENTITY_SUCCESS = 'update:basic_message_entity_success'
export const UPDATE_SESSION_MESSAGE_ENTITY = 'update:session_message_entity'
export const UPDATE_SESSION_MESSAGE_ENTITY_SUCCESS = 'update:session_message_entity_success'
